module.exports = __webpack_public_path__ + "img/waiting.612e116c.gif";